import React from 'react';
import * as PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Button, ButtonContainer, ButtonX } from 'components/button/index';

export const AddNewGroupModal = withTranslation()(
  class extends React.Component {
    static propTypes = {
      show: PropTypes.bool.isRequired,
      onClose: PropTypes.func,
    };

    componentDidMount() {
      document.getElementById('policy-name').addEventListener(
        'keydown',
        (e) => {
          const keyName = e.key;

          if (keyName === 'Enter') {
            e.preventDefault();
            const policyName = e.currentTarget.value;
            this.props.onClose(policyName);
            e.currentTarget.value = '';
          }
        },
        false
      );
    }

    addPolicy = (e) => {
      e.preventDefault();
      const policyName = e.target.elements.namedItem('policy-name').value;
      this.props.onClose(policyName);
      e.target.elements.namedItem('policy-name').value = '';
    };

    closeModal = (e) => {
      e.preventDefault();
      this.props.onClose();
    };

    holdOpen = (event) => {
      event.stopPropagation();
    };

    render() {
      const { t } = this.props;
      return (
        <div
          className={'modal fade ' + (this.props.show ? 'show show-modal' : 'hide-modal')}
          id="AddNewModal"
          tabIndex="-1"
          aria-hidden="true"
          onClick={this.closeModal}
        >
          <div className="modal-dialog" role="document" onClick={this.holdOpen}>
            <form onSubmit={this.addPolicy}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {t('add_new_policy')}
                  </h5>
                  <ButtonX onClick={this.closeModal}>
                    <span aria-hidden="true">
                      <b>&times;</b>
                    </span>
                  </ButtonX>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-12">
                      <input
                        className="form-control"
                        type="text"
                        id="policy-name"
                        name="policy-name"
                        placeholder={t('enter_group_organizational_unit')}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <ButtonContainer>
                    <Button onClick={this.closeModal} secondary={true}>
                      {t('close')}
                    </Button>
                    <Button type={'submit'}>{t('add_policy')}</Button>
                  </ButtonContainer>
                </div>
              </div>
            </form>
          </div>
        </div>
      );
    }
  }
);
